import { activeModule } from "../providers/active-module";
import CoreClients from "./src/shared/client";
import { DataClients } from "./types";
import { Clients as FourTimeClients } from "../4time/clients";
import { Clients as IrsKomClients } from "../IrsKom/clients";
import { Clients as Parhato2Clients } from "../parhato2/clients";

const modulesClients: Record<string, Partial<DataClients>> = {
  "4TIME": FourTimeClients,
  IRSKOM: IrsKomClients,
  PARHATO2: Parhato2Clients,
};

let Clients: DataClients = CoreClients;

const moduleName = activeModule;
if (modulesClients[moduleName]) {
  Clients = { ...CoreClients, ...modulesClients[moduleName] };
}

export const {
  authClient,
  categoriesClient,
  usersClient,
  settingsClient,
  bannersClient,
  ordersClient,
  paymentMethodsClient,
  shippingMethodsClient,
  paymentClient,
  productsClient,
  shippingZonesClient,
  couponsClient,
  deliveryDatesClient,
  addressClient,
  referralClient,
  customerSurveyClient,
  storiesClient,
  cartClient,
  cardsClient,
  promoClient,
  recipeClient,
  pageItemsClient,
  notificationsClient,
  chatClient,
} = Clients;

export const { getReferralPoints } = referralClient;
